import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { storeHasPromotions } from '../utils/promotions';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Live promotions to show on the home page: a signed-in customer gets theirs
// (general ones plus any aimed at them); a visitor gets the general ones.
// Nothing is fetched when the store doesn't have Promotions switched on.
export const usePromotions = () => {
  const { user, storeSettings } = useAuth();
  const [promotions, setPromotions] = useState([]);
  const enabled = storeHasPromotions(storeSettings);
  const customerStore = user?.role === 'customer' ? user.admin_id : null;
  const storeId = customerStore || storeSettings?.admin_id;

  useEffect(() => {
    if (!enabled || !storeId) { setPromotions([]); return undefined; }
    let cancelled = false;
    const url = customerStore ? `${API}/customer/promotions` : `${API}/store/${storeId}/promotions`;
    axios.get(url)
      .then((res) => { if (!cancelled) setPromotions(Array.isArray(res.data) ? res.data : []); })
      .catch(() => { if (!cancelled) setPromotions([]); });
    return () => { cancelled = true; };
  }, [enabled, storeId, customerStore]);

  return promotions;
};
